import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { SectionType } from '../typings'
import { selectAllSalesFunnelStages } from '../slice'
import type { ENTITY_TYPES } from '@sales-center/common'

export const useSelectFunnelStagesByType = (
  funnelId: number,
  type: SectionType | ENTITY_TYPES,
  sortByName: boolean = false,
) => {
  const stages = useSelector(selectAllSalesFunnelStages)
  return useMemo(() => {
    let result = stages.filter(
      (x) =>
        x.sectionType.toLowerCase() === type.toLowerCase() &&
        (funnelId === -1 || x.salesFunnelId == funnelId),
    )
    if (sortByName) {
      result = result.sort((a, b) => a.name.localeCompare(b.name))
    }
    return result
  }, [funnelId, type, stages, sortByName])
}
